import { Subscription, timer, BehaviorSubject, filter, tap, switchMap } from 'rxjs';
import { ADMIN_API } from '../AdminAPI';
import { Branch, getOnTimeDiffMS, isAPIResponse } from '@golden/gdk-base';
export function createRealTimeService(api, trunk, adminModule) {
    const polling$ = new BehaviorSubject({
        minuteDenominator: 3,
        secondDenominator: 0
    });
    const updateList = [];
    let subscription = new Subscription();
    const start = () => {
        updateList.forEach((obs) => subscription.add(obs.subscribe()));
    };
    const reset = () => {
        if (subscription && !subscription.closed) {
            subscription.unsubscribe();
            subscription = new Subscription();
        }
    };
    const filterAPI = (api) => {
        return filter((res) => isAPIResponse(res, api));
    };
    // AuthService
    updateList.push(api.base.responses.pipe(filterAPI(ADMIN_API.ADMIN_LOGOUT), tap(() => {
        reset();
        start();
    })));
    // Me
    updateList.push(polling$.pipe(switchMap(time => timer(getOnTimeDiffMS(time), time.minuteDenominator * 60 * 1000 + time.secondDenominator * 1000)), filter(() => adminModule.auth.isLoggedIn.value && !adminModule.auth.isWrong.value), tap(() => trunk.next([Branch.ME, Branch.ADMIN_FINANCE_ALERT, Branch.ADMIN_COMPLAIN_ALERT, Branch.ADMIN_ALERT_RECENT]))));
    return {
        get isEnable() {
            return !subscription.closed;
        },
        set isEnable(value) {
            if (value)
                start();
            else
                reset();
        },
        updatePollingTime: (time) => {
            polling$.next(time);
        }
    };
}
//# sourceMappingURL=RealTimeService.js.map